import React, { FC } from 'react';

import getClassName from 'src/common/utils/getClassName';
import SupportEmail from '../SupportEmail';
import SupportPhoneNumber from '../SupportPhoneNumber';
import s from './ContactSupport.module.scss';

type ContactSupportProps = {
  classNameModifier: string;
};

const ContactSupport: FC<ContactSupportProps> = ({
  classNameModifier,
}) => (
  <div className={getClassName(s, 'root', classNameModifier)}>
    <p className={getClassName(s, 'text', classNameModifier)}>
      Please contact Getmyboat customer support if you need to make changes to this booking.
    </p>
    <ul className={s.contacts}>
      <li>
        <SupportPhoneNumber
          className={getClassName(s, 'supportLink', classNameModifier)}
        />
      </li>
      <li className={s.email}>
        <SupportEmail
          className={getClassName(s, 'supportLink', classNameModifier)}
        />
      </li>
    </ul>
  </div>
);

export default ContactSupport;
